import {Dispatch, FC, SetStateAction, useEffect, useMemo, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useFormContext} from 'react-hook-form'
import {Column} from 'react-table'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {ScheduleAssignmentFilter} from '../../../../model/assigment.model'
import {getListScheduling} from '../../../../services/assigment.services'
import {ModalAddObservation} from './add-observation'
import {MULTI_USER_CREW_SERVICES} from '../../../../services/multi-user-crew.service'
import {ServicePendingDto} from '../../../../model/multiUserCrew.model'
import {formatDate} from '../../../../../../util/dates'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
}

export const ModalCleaningActivities: FC<Props> = ({show, setShow}) => {
  const {
    data,
    setData,
    setPagination,
    setLoading,
    pagination,
    selectedOn,
    clearSelected,
    selected,
    onSelect,
    loading,
  } = useKTable()

  const [showForm, setShowForm] = useState(false)

  const handleOpenModal = (props: any) => {
    setShowForm(true)
  }

  const {watch, setValue, setError} = useFormContext()

  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Servicio Limpieza' />,
        accessor: 'Actividad',
        Cell: ({value}) => value || '-',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Estado' />,
        accessor: 'EstadoEscaneoActividad',
        Cell: ({value}) => value || '-',
      },
    ],
    [],
  )

  useEffect(() => {
    getActivitiesByCampamentoList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, show])

  const getActivitiesByCampamentoList = async () => {
    try {
      // setSearching(true)
      setLoading(true)
      // Formatear fechas al formato ISO 8601 completo
      const fechaInicio = formatDate(new Date())
      const fechaFin = formatDate(new Date())
      const campamentoId = watch('CampamentoId')
      const programacionServicioId = watch('ProgramacionServicioId')

      // Si campamento es "TODOS" (null), no enviar CampamentoId ni ServiceSchedulingId
      const isCampamentoTodos = !campamentoId || campamentoId === null || campamentoId === ''

      const filters: ServicePendingDto = {
        ...(isCampamentoTodos ? {} : {CampamentoId: campamentoId}),
        ...(isCampamentoTodos ? {} : {ServiceSchedulingId: programacionServicioId}),
        FechaIni: fechaInicio,
        FechaFin: fechaFin,
        Estados: ['1', '3'],
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      }

      const {data: response} = await MULTI_USER_CREW_SERVICES.getListPendingScan(filters)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }

      // const {data: response} = await getListScheduling(filters)

      // if (!response.error && response.data) {
      //   setData(response.data)
      //   setPagination({
      //     currentPage: filters.pageNumber || 1,
      //     perPage: filters.size || 10,
      //     totalResults: response.total || 0,
      //   })
      // } else {
      //   setData([])
      //   setPagination({
      //     currentPage: 1,
      //     perPage: 10,
      //     totalResults: 0,
      //   })
      // }
    } catch (error) {
      console.error('Error al buscar programaciones:', error)
      setData([])
      setPagination({
        currentPage: 1,
        perPage: 10,
        totalResults: 0,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setShow(false)
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      size='xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Servicios de Limpieza</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <KTable
            data={data}
            columns={columns as any}
            getRowClassName={(row) => {
              if (row.original.EstadoEscaneoActividad === 'COMPLETADO') return 'bg-light-success'
              if (row.original.EstadoEscaneoActividad === 'OBSERVADO') return 'bg-light-warning'
              if (row.original.EstadoEscaneoActividad === 'PENDIENTE') return 'bg-light'
              return ''
            }}
          />
        </div>
        <ModalAddObservation show={showForm} setShow={setShowForm} />
      </div>
    </Modal>
  )
}
